import { Location, NavigateFunction } from "react-router-dom";
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils";
import { extractUrlRegion } from "reusable/utils/url-utils";

export default class RegionRouterStore {
   sp

   constructor(sp: { navigate: NavigateFunction, location: Location }) {
      this.sp = sp
   }

   get region() {
      return extractUrlRegion(this.sp.location).region
   }

   get pathWithoutRegion() {
      return extractUrlRegion(this.sp.location).path
   }

   get baseWithRegion() {
      return `${window.location.origin}/${this.region}`
   }

   navigate = (path?: string, withReload?: boolean) => {
      let route = `/${this.region}`
      if (path) {
         path = path[0] === '/' ? path.substring(1) : path
         route += `/${path}`
      }

      // Preserve query parameters if OAuth redirect is detected
      if (window.location.search.includes('oauth_redirect=true') && window.location.search) {
         route += window.location.search
      }

      if (withReload) {
         window.location.href = route
      } else {
         this.sp.navigate(route)
      }
   }
}

export const { Provider: RegionRouterStoreProvider, useProvidedStore: useRegionRouterStore } =
   createStoreContext(RegionRouterStore)
